/* eslint-disable react/prop-types */
import React from 'react';
import { Button } from '../ui';

const Pagination = ({ table, variant = 'default' }) => {
  const rowCount = Object.keys(table?.getRowModel()?.rowsById || {}).length;
  const isDateGroup = variant === 'dateGroup';

  return (
    <div
      className={`flex items-center justify-between px-4 py-3 ${
        isDateGroup
          ? 'border-t border-slate-200 bg-slate-50/80 dark:border-strokedark dark:bg-meta-4/80'
          : 'rounded-b-lg bg-gray-100 dark:bg-meta-4'
      }`}
    >
      <div className="flex items-center space-x-2">
        <Button
          onClick={() => table.setPageIndex(0)}
          disabled={!table.getCanPreviousPage()}
          size="sm"
          variant={isDateGroup ? 'outline' : 'primary'}
        >
          {'<<'}
        </Button>
        <Button
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
          size="sm"
          variant={isDateGroup ? 'outline' : 'primary'}
        >
          {'<'}
        </Button>
        <Button
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}
          size="sm"
          variant={isDateGroup ? 'outline' : 'primary'}
        >
          {'>'}
        </Button>
        <Button
          onClick={() => table.setPageIndex(table.getPageCount() - 1)}
          disabled={!table.getCanNextPage()}
          size="sm"
          variant={isDateGroup ? 'outline' : 'primary'}
        >
          {'>>'}
        </Button>
      </div>
      <div
        className={`flex items-center space-x-4 text-sm ${
          isDateGroup
            ? 'text-slate-500 dark:text-slate-400'
            : 'text-gray-700 dark:text-slate-300'
        }`}
      >
        <span
          className={`font-semibold ${
            isDateGroup
              ? 'text-slate-700 dark:text-slate-200'
              : 'text-gray-800 dark:text-slate-100'
          }`}
        >
          Count: {rowCount}
        </span>
        <span
          className={
            isDateGroup
              ? 'text-slate-500 dark:text-slate-400'
              : 'text-gray-700 dark:text-slate-300'
          }
        >
          Page{' '}
          <strong
            className={
              isDateGroup
                ? 'text-slate-700 dark:text-slate-200'
                : 'text-gray-800 dark:text-slate-100'
            }
          >
            {table.getState().pagination.pageIndex + 1} of{' '}
            {table.getPageCount()}
          </strong>
        </span>
        <select
          value={table.getState().pagination.pageSize}
          onChange={e => table.setPageSize(Number(e.target.value))}
          className={`relative z-20 w-32 appearance-none px-3 py-2 text-sm font-medium outline-none transition active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary ${
            isDateGroup
              ? 'rounded-md border border-slate-200 bg-white text-slate-600 focus:border-primary focus:shadow-[0_0_0_4px_rgba(59,130,246,0.08)] dark:border-strokedark dark:bg-boxdark dark:text-slate-200'
              : 'rounded border border-stroke bg-transparent text-gray-700 focus:border-primary dark:border-strokedark dark:bg-boxdark dark:text-slate-200'
          }`}
        >
          {[5, 10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default Pagination;
